import { action, ActionType } from "typesafe-actions";
import { Nullable } from "../../../types/common";
import { IError } from "../../../redux/actions/errorHandlingAction";
import { TResourceType } from "../../../types/resources/resources.types";
import { SearchResults } from "../../../types/search/search-results.interface";
import { IComment } from "../types/icomment.interface";

export enum CommentsActions {
  Fetch = "Comments/Fetch",
  FetchFailure = "Comments/FetchFailure",
  FetchSuccess = "Comments/FetchSuccess",

  Post = "Comments/Post",
  PostFailure = "Comments/PostFailure",
  PostSuccess = "Comments/PostSuccess",

  ResetState = "Comments/ResetState",
}

export const fetch = (resourceId: number, resourceType: TResourceType) =>
  action(CommentsActions.Fetch, { resourceId, resourceType });
export const fetchFailure = (error: Nullable<IError>) =>
  action(CommentsActions.FetchFailure, error);
export const fetchSuccess = (results: SearchResults<IComment>) =>
  action(CommentsActions.FetchSuccess, results);

export const post = (resourceId: number, resourceType: TResourceType, comment: string) =>
  action(CommentsActions.Post, { resourceId, resourceType, comment });
export const postFailure = (error: Nullable<IError>) => action(CommentsActions.PostFailure, error);

export const postSuccess = (comments: SearchResults<IComment>) =>
  action(CommentsActions.PostSuccess, comments);

export const resetState = () => action(CommentsActions.ResetState);

const actionCreators = {
  fetch,
  fetchFailure,
  fetchSuccess,

  post,
  postFailure,
  postSuccess,

  resetState,
};

export type CommentsActionsType = ActionType<typeof actionCreators>;
